import { render, staticRenderFns } from "./CollectionHashTagManage.vue?vue&type=template&id=afb81958&scoped=true&"
import script from "./CollectionHashTagManage.vue?vue&type=script&lang=js&"
export * from "./CollectionHashTagManage.vue?vue&type=script&lang=js&"
import style0 from "./CollectionHashTagManage.vue?vue&type=style&index=0&id=afb81958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb81958",
  null
  
)

export default component.exports